module.exports = "fragment Voucher on CartVoucherType{id code description}"